import L from 'leaflet'
import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'

// Versión de la app, se muestra en el diálogo Info.
const VERSION = '1.1'

/**
 * Modo desarrollo.
 *
 * Ya NO conmuta URLs: todas son relativas a la raíz del sitio y valen igual en
 * desarrollo y en producción. Sólo queda para que el geo-visualizador use
 * fixtures locales en lugar del endpoint lsdata2.php, que no puede servirse
 * desde public/.
 *
 * Se deriva del entorno a propósito: cuando era una constante manual quedó un
 * build de producción con TEST=1 y el portal-agro sirvió fixtures viejos en
 * lugar de consultar lsdata2.php.
 */
const TEST = process.env.NODE_ENV === 'development' ? 1 : 0

// Rutas relativas a la raíz del sitio. En desarrollo los archivos se sirven
// desde public/ replicando esta misma estructura.
const URL_BASE = '/'
const URL_BASE_DATA_REPORTES = '/reportes/'
const URL_DATOS_ABIERTOS = '/reportes/datos_abiertos/'
// Los logos viajan dentro del build (public/assets/img), asi no dependen de
// que existan en una ruta del servidor. PUBLIC_URL es '.' en produccion por
// el homepage relativo, y '' en desarrollo.
const URL_BASE_IMAGENES = process.env.PUBLIC_URL + '/assets/img/'

// Portal Drupal: navegación fuera de la app, se mantiene absoluta.
const PORTAL_INUMET = 'https://www.inumet.gub.uy/'

const CENTRO_URUGUAY = [-35.01667, -55]

const DEFAULT_ZOOM = 8

const MAP_LAYERS_OPACITY_DEFAULT = 0.8

// Defino el marcador por defecto para Leaflet

let DefaultIcon = L.icon({
    iconUrl: icon,
    iconAnchor: [12, 41],
    shadowUrl: iconShadow,
    shadowAnchor: [12, 41],
})
L.Marker.prototype.options.icon = DefaultIcon

export default {
    VERSION,
    TEST,
    URL_BASE,
    URL_BASE_DATA_REPORTES,
    URL_BASE_IMAGENES,
    URL_DATOS_ABIERTOS,
    PORTAL_INUMET,
    CENTRO_URUGUAY,
    DEFAULT_ZOOM,
    MAP_LAYERS_OPACITY_DEFAULT,
}
